import request from '../request';
const baseUrl = process.env.NODE_ENV !== 'production'
    ? 'enterprise' // 开发环境
    : 'enterprise'; // 生产环境
// export function getCompanyDynamics (params) {
//   return request.post(baseUrl + '/company/companyDynamics/dataList', params)
// }
// 获取平台下的公司选项
export function getCompanyByClass(params) {
    return request.post(baseUrl + '/options/corp/class', params);
}
// 通过公司名查找公司(平台上所有公司)
export function getCompanyBySearchApi(params) {
    return request.post(baseUrl + '/corp/search', params);
}
// 【选项】通过公司名查找公司(平台上所有公司)
export function getOptionsCorpSearchApi(params) {
    return request.post(baseUrl + '/options/corp/search', params);
}
// 获取企业下的节点选项
export function getCompanyNodes(random) {
    return request.post(baseUrl + '/options/node', random);
}
// 获取企业下的公司选项
export function getCompanys(random) {
    return request.post(baseUrl + '/options/corp', random);
}
// 获取企业下的部门选项
export function getCompanyDepartment(random) {
    return request.post(baseUrl + '/options/dept', random);
}
// 获取企业下的资产（船/货）选项
export function getCompanyAssetsApi(random) {
    return request.post(baseUrl + '/options/assets', random);
}
// 获取企业下的 工作-职务 选项
export function getJobProfessionOwned(random) {
    return request.post(baseUrl + '/options/job/profession/owned', random);
}
// 获取企业下的 工作-职位 选项
export function getJobPositionOwned(random) {
    return request.post(baseUrl + '/options/job/position/owned', random);
}
// 获取企业下的 工作 选项
export function getJob(random) {
    return request.post(baseUrl + '/options/job', random);
}
// 获取 平台工作-职务 选项
export function getJobProfession(params) {
    return request.post(baseUrl + '/options/job/profession', params);
}
// 获取 节点组织结构数据
export function getEnterpriseStructure(random) {
    return request.post(baseUrl + '/structure', random);
}
// 编辑/添加节点信息
export function updateEnterpriseNodeApi(nodeName, type, id) {
    return request.post(baseUrl + '/node/edit', { node_name: nodeName, type, id });
}
// 删除节点
export function delEnterpriseNodeApi(id) {
    return request.post(baseUrl + '/node/del', { id });
}
// 编辑/添加公司
export function editEnterpriseCorpApi(params) {
    return request.post(baseUrl + '/corp/edit', params);
}
// 节点绑定公司
export function enterpriseNodeBindCorpApi(nodeId, corpId) {
    return request.post(baseUrl + '/node/bind', { node_id: nodeId, corp_id: corpId });
}
// 编辑/添加部门
export function editEnterpriseDeptApi(params) {
    return request.post(baseUrl + '/dept/edit', params);
}
// 获取节点详情
export function getEnterpriseNodeDetailApi(id) {
    return request.post(baseUrl + '/node/detail', { id });
}
// 获取公司动态/列表数据（分类、分页）
export function getEnterpriseCorpOwnedApi(companyClass, page) {
    return request.post(baseUrl + '/corp/owned', { class: companyClass, page });
}
// 获取指定公司详情
export function getEnterpriseCorpDetailApi(id) {
    return request.post(baseUrl + '/corp/detail', { id });
}
// 删除公司/将公司放入回收站
export function trashEnterpriseCorpApi(id) {
    return request.post(baseUrl + '/corp/trash', { id });
}
// 强制删除公司
export function deleteEnterpriseCorpApi(id) {
    return request.post(baseUrl + '/corp/delete', { id });
}
// 恢复公司
export function recycleEnterpriseCorpApi(id) {
    return request.post(baseUrl + '/corp/recycle', { id });
}
// 收藏公司
export function enterpriseCorpCopyApi(sourceId, nodeId) {
    return request.post(baseUrl + '/corp/copy', { sourceId, nodeId });
}
// 获取部门动态/列表数据
export function getEnterpriseDeptOwnedApi(deptClass, page) {
    return request.post(baseUrl + '/dept/owned', { class: deptClass, page });
}
// 获取指定部门详情
export function getEnterpriseDeptDetailApi(id) {
    return request.post(baseUrl + '/dept/detail', { id });
}
// 删除部门/将部门放入回收站
export function trashEnterpriseDeptApi(id) {
    return request.post(baseUrl + '/dept/trash', { id });
}
// 强制删除部门
export function deleteEnterpriseDeptApi(id) {
    return request.post(baseUrl + '/dept/delete', { id });
}
// 恢复部门
export function recycleEnterpriseDeptApi(id) {
    return request.post(baseUrl + '/dept/recycle', { id });
}
// 获取部门下的入职/离职历史记录
export function getDeptEmployeeHistoryApi(id) {
    return request.post(baseUrl + '/dept/employee/history', { id });
}
// 获取企业下的公司选项
export function getEnterpriseOptionsCorpApi(random) {
    return request.post(baseUrl + '/options/corp', { random });
}
// 编辑公司简介
export function editCorpIntroductionApi(id, introduction) {
    return request.post(baseUrl + '/corp/introduction/edit', { id, introduction });
}
// 职位职务
// 获取工作列表数据
export function getEnterpriseJobOwnedApi(jobClass, page) {
    return request.post(baseUrl + '/job/owned', { class: jobClass, page });
}
// 搜索平台上所有的工作
export function getEnterpriseJobSearchApi(params) {
    return request.post(baseUrl + '/job/search', params);
}
// 工作 添加/编辑
export function enterpriseJobEditApi(params) {
    return request.post(baseUrl + '/job/edit', params);
}
// 收藏工作
export function enterpriseJobCopyApi(id) {
    return request.post(baseUrl + '/job/copy', { id });
}
// 删除工作/将工作放入回收站
export function enterpriseJobTrashApi(id) {
    return request.post(baseUrl + '/job/trash', { id });
}
// 恢复工作
export function enterpriseJobRecycleApi(id) {
    return request.post(baseUrl + '/job/recycle', { id });
}
// 强制删除工作
export function enterpriseJobDeleteApi(id) {
    return request.post(baseUrl + '/job/delete', { id });
}
// 获取指定工作岗位详情
export function getEnterpriseJobDetailApi(id) {
    return request.post(baseUrl + '/job/detail', { id });
}
// 获取指定工作下的员工列表数据
export function getEnterpriseJobWorkerListApi(id) {
    return request.post(baseUrl + '/job/worker/list', { id });
}
// 获取 平台工作-职务 选项
export function getOptionsJobProfessionApi(identity, page) {
    return request.post(baseUrl + '/options/job/profession', { identity, page });
}
// 获取 平台工作-职位 选项
export function getOptionsJobPositionApi(identity, page) {
    return request.post(baseUrl + '/options/job/position', { identity, page });
}
// 获取 获取不同身份的权限结构
export function getPermissionTreeApi(identity) {
    return request.post(baseUrl + '/permission/tree', { identity });
}
// 获取企业下的 工作 选项
export function getOptionsJobApi(identity, page) {
    return request.post(baseUrl + '/options/job', { identity, page });
}
// 招聘职员
export function employeeRecruitApi(userId, userSerialNo, deptId, jobId) {
    return request.post(baseUrl + '/employee/recruit', { userId, userSerialNo, deptId, jobId });
}
// 【Offer】添加Offer
export function offerAddApi(userIds, jobId, deptId, ttl) {
    return request.post(baseUrl + '/offer/add', { userIds, jobId, deptId, ttl });
}
// 解雇职员
export function employeeDismissApi(offerId) {
    return request.post(baseUrl + '/employee/dismiss', { offerId });
}
// 获取企业下的职员列表
export function getEmployeeListApi(staffClass, page) {
    return request.post(baseUrl + '/employee/list', { class: staffClass, page });
}
// 【Offer】Offer列表
export function getOfferListApi(staffClass, page) {
    return request.post(baseUrl + '/offer/list', { class: staffClass, page });
}
// 【工作】获取指定工作和部门下的员工列表数据
export function getJobWorkerListApi(id, deptId, staffClass) {
    return request.post(baseUrl + '/job/worker/list', { id, deptId, class: staffClass });
}
// 【工作】获取部门下的职务职位列表
export function getJobStatisticsDepttApi(deptId) {
    return request.post(baseUrl + '/job/statistics-dept', { deptId });
}
// 搜索企业下的职员列表
// identity部门访问身份；employee_city自然人城市IDemployee_name自然人姓/名；dept_city部门城市ID；dept_name部门名称
export function employeeSearchApi(params) {
    return request.post(baseUrl + '/employee/search', params);
}
// 获取企业下的职员详情
export function getEmployeeDetailApi(offerId) {
    return request.post(baseUrl + '/employee/detail', { offerId });
}
// 【Offer】取消Offer
export function offerCancelApi(id) {
    return request.post(baseUrl + '/offer/cancel', { id });
}
// 切换员工的工作
export function employeeJobSwitchApi(userId, deptId, jobId) {
    return request.post(baseUrl + '/employee/job/switch', { userId, deptId, jobId });
}
// 获取offer详情
export function getOfferDetail(method, identifier) {
    return request.post(baseUrl + '/offer/detail', { method, identifier });
}
// 【职员】获取企业下所有在职职员详情
export function getEmployeeListNormalDetailApi(random) {
    return request.post(baseUrl + '/employee/list/normal/details', { random });
}
// 【公司】从缓存数据中获取公司结构数据
// identity身份类型
export function enterpriseCorpExtensionSearchApi(params) {
    return request.post(baseUrl + '/corp/extension/search', params);
}
// 【HR】搜索指定账户关联的企业管理员
export function adminsSearchApi(account) {
    return request.post(baseUrl + '/admins/search', { account });
}
// 【HR】搜索指定账户关联的企业管理员
export function enterpriseAdminsApi() {
    return request.post(baseUrl + '/admins');
}
// 【HR】更新企业的管理员设置
export function enterpriseAdminsUpdateApi(params) {
    return request.post(baseUrl + '/settings/admins/update', params);
}
export default { getEnterpriseStructure };
